
(async () => {
  var _pdp = document.querySelectorAll("section.pdp-specs > H2");
    // console.log(_pdp)
        for (var i = 0; i < _pdp.length; i++) {
            _pdp[i].addEventListener('click', function (e) {
               // console.log(this.firstChild.nextElementSibling.lastChild.previousElementSibling)
                this.nextElementSibling.classList.toggle('hide');
                this.firstChild.nextElementSibling.lastChild.previousElementSibling.classList.toggle('rotate');
            })
        }
  })();